export function revokeSentGalleryItems(items) {
  items.forEach((it) => {
    if (it.previewUrl) URL.revokeObjectURL(it.previewUrl)
  })
}
